const prefix = 'support-packages-page';

export const i18n = {
    createdAt: {
        id: `${prefix}.createdAt`,
        defaultMessage: 'Created At',
    },
    username: {
        id: `${prefix}.username`,
        defaultMessage: 'Username',
    },
    message: {
        id: `${prefix}.message`,
        defaultMessage: 'Message',
    },
    download: {
        id: `${prefix}.download`,
        defaultMessage: 'Download',
    },
    clickToDownload: {
        id: `${prefix}.clickToDownload`,
        defaultMessage: 'Click to download',
    },
    noPackagesTitle: {
        id: `${prefix}.noPackagesTitle`,
        defaultMessage: 'No support packages',
    },
    noPackagesMessage: {
        id: `${prefix}.noPackagesMessage`,
        defaultMessage: 'There are no support packages to display.',
    },
} as const;
